import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BASE_API_URL} from '../config/app.config';
import {ParkProvider} from '@providers/park.provider';
import {ThingModalEvent} from "@events/ThingModalEvent";
import { ThingsUtil } from '../util/things';

// used to resolve type check on the results
export interface ThingsResult {
  results: any[]
}

@Injectable()
export class ThingProvider {

  constructor(private http: HttpClient, private thingEvent: ThingModalEvent, private thingsUtil: ThingsUtil) {}

  async getThing(thingId) {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thingId);

    return await this.http.get<any>(url, {}).toPromise();
  }

  async getThings(options: any = {}) {
    const url = BASE_API_URL + 'things';
    let queryParams = new HttpParams();
    let things: ThingsResult

    if (options.types) {
      queryParams = queryParams.append('types', options.types);
    }
    if (options.areas) {
      queryParams = queryParams.append('areas', options.areas);
    }
    if (options.status) {
      queryParams = queryParams.append('includeStatus', options.status);
    }
    if (options.representation) {
      queryParams = queryParams.append('representation', options.representation);
    }

    await this.http.get<any>(url, {
      params: queryParams
    }).toPromise().then(async (res: ThingsResult)=> {
      things = res;
    });

    return await things;
  }

  getThingSensorReadings(thingId) {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thingId) + '/sensorReadings';

    let promise = new Promise((resolve, reject) => {
      this.http.get(url).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

  addThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things';

    let promise = new Promise((resolve, reject) => {
      this.http.post(url, thing, {}).toPromise().then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });

    return promise;
  }

  updateThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId);

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.put(url, thing, {}).toPromise().then(res => {
        console.log('updating thing: ', thing);
        this.thingEvent.fire("thing.update", thing); // broadcast thing was updated
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });

    return promise;
  }

  updateThresholdConfig(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId) + '/thresholds';

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.put(url, thing, {}).toPromise().then(res => {
        this.thingEvent.fire("thing.update", thing); // broadcast thing was updated
        resolve(res);
      })
    });

    return promise;
  }

  activateThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + thing.thingId + '/activate';

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.post(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

  openThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId) + '/open';

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.post(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

  closeThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId) + '/close';

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.post(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

  deactivateThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId) + '/deactivate';

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.post(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }

  deleteThing(thing): Promise<any> {
    const url = BASE_API_URL + 'things/' + encodeURIComponent(thing.thingId);

    let promise = new Promise((resolve, reject) => {
      if (! thing.thingId) {
        reject('thingId is required.');
      }

      this.http.delete(url, {}).toPromise().then(res => {
        resolve(res);
      });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/providers/thing.provider.ts